var map = {
	"./SpaceManagement.vue": "D2i+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1LwL";


//////////////////
// WEBPACK FOOTER
// ./src/pages/PartII/SpaceManagement/components nonrecursive \.vue$
// module id = 1LwL
// module chunks = 1